import React from 'react';
import {useDispatch} from 'react-redux';
import {Route} from 'react-router';
import useOnNavigateAway from 'Shared/utilities/useOnNavigateAway';
import IndependentAgentEntry from 'Users/components/AgentAdministration/AgencyAdministratorAgentEntry/IndependentAgentEntry';
import AgentManualEntry from 'Users/components/AgentAdministration/AgentManualEntry';
import VipEntry from 'Users/components/AgentAdministration/VipEntry';
import SingleSignOnAccount from 'Users/components/SingleSignOn/SingleSignOnAccount';
import SingleSignOnAccounts from 'Users/components/SingleSignOn/SingleSignOnAccounts';
import UserAdministration from 'Users/components/UserAdministration/UserAdministration';
import UserProfile from 'Users/components/UserProfile/UserProfile';
import {clearUserAdministrationFilter} from 'Users/ducks/userAdministration';
import UserManualEntry from './components/UserAdministration/UserEntry/UserManualEntry';

const ROOT_URI = '/users';
export const UserRouteConstants = {
  ADD_AGENT: `${ROOT_URI}/agents/add`,
  ADD_SUPPORT_AGENT: `${ROOT_URI}/agents/add?isSupport=true`,
  ADD_VIP: `${ROOT_URI}/VIPs/add`,
  ADD_USER: `${ROOT_URI}/User/Add`,
  EDIT_USER: (userId: string) => `${ROOT_URI}/User/${userId}/edit`,
  EDIT_AGENT: (agentId: string) => `${ROOT_URI}/agents/edit/${agentId}`,
  EDIT_SUPPORT_AGENT: (agentId: string) => `${ROOT_URI}/agents/edit/${agentId}?isSupport=true`,
  EDIT_VIP_USER: (userId: string) => `${ROOT_URI}/VIPs/edit/${userId}`,
  INDEPENDENT_AGENT_PREREGISTRATION: `${ROOT_URI}/agents/independent/preregistration`,
  EXTERNAL_USER_REGISTRATION: (userKey: string) => `${ROOT_URI}/external/registration?key=${userKey}`,
  EXTERNAL_USER_SIGN_UP: (iaKey: string) => `${ROOT_URI}/external/registration/${iaKey}`,
  INDEPENDENT_AGENT_SUPPORT: `${ROOT_URI}/agents/independent/preregistration?isSupport=true`,
  PASSWORD_RECOVERY: `${ROOT_URI}/recovery/password`,
  PASSWORD_RECOVERY_SHOW_SECURITY_QUES: `${ROOT_URI}/recovery/password/securityQues`,
  PASSWORD_RECOVERY_EMAIL_SENT: `${ROOT_URI}/recovery/password/emailSent`,
  PASSWORD_RESET_FORM: (requestKey: string) => `${ROOT_URI}/recovery/password/reset/${requestKey}`,
  PASSWORD_RESET_REQUEST_EXPIRED: `${ROOT_URI}/recovery/password/resetExpired`,
  PROFILE: `${ROOT_URI}/profile`,
  REGISTRATION: `${ROOT_URI}/registration`,
  SIGN_UP: `${ROOT_URI}/signup`,
  USERNAME_RECOVERY: `${ROOT_URI}/recovery/username`,
  USERS: ROOT_URI,
  SSO_ACCOUNTS: `${ROOT_URI}/ssoAccounts`,
  ADD_SSO_ACCOUNT: `${ROOT_URI}/ssoAccount/add`,
  EDIT_SSO_ACCOUNT: (username: string) => `${ROOT_URI}/ssoAccount/edit?username=${encodeURIComponent(username)}`,
};

export default () => {
  const dispatch = useDispatch();
  useOnNavigateAway(UserRouteConstants.USERS, () => {
    dispatch(clearUserAdministrationFilter());
  });

  return (
    <Route
      path={`/users`}
      render={() => (
        <>
          <Route exact path={`${ROOT_URI}/ssoAccount/edit`} render={() => <SingleSignOnAccount />} />
          <Route exact path={UserRouteConstants.ADD_SSO_ACCOUNT} render={() => <SingleSignOnAccount />} />
          <Route exact path={UserRouteConstants.SSO_ACCOUNTS} render={() => <SingleSignOnAccounts />} />
          <Route exact path={UserRouteConstants.PROFILE} render={() => <UserProfile />} />
          <Route
            exact
            path={UserRouteConstants.SIGN_UP}
            // @ts-ignore
            render={routeProps => <IndependentAgentEntry {...routeProps} />}
          />
          <Route
            exact
            path={UserRouteConstants.ADD_AGENT}
            render={routeProps => <AgentManualEntry {...routeProps} />}
          />
          <Route
            exact
            path={UserRouteConstants.EDIT_AGENT(':agentId')}
            render={routeProps => <AgentManualEntry {...routeProps} />}
          />
          <Route
            exact
            path={UserRouteConstants.INDEPENDENT_AGENT_PREREGISTRATION}
            // @ts-ignore
            render={routeProps => <IndependentAgentEntry {...routeProps} />}
          />
          <Route exact path={UserRouteConstants.USERS} render={() => <UserAdministration />} />

          <Route exact path={UserRouteConstants.ADD_USER} render={() => <UserManualEntry />} />
          <Route exact path={UserRouteConstants.EDIT_USER(':userId')} render={() => <UserManualEntry />} />

          <Route exact path={UserRouteConstants.ADD_VIP} render={() => <VipEntry />} />
          <Route exact path={UserRouteConstants.EDIT_VIP_USER(':userId')} render={() => <VipEntry />} />
        </>
      )}
    />
  );
};
